<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>S.M.</p>
<p>We endured hell together, and since we’ve both left, I know I can do anything with you in my corner… I now have three published books and multiple film projects as proof. I love you.</p><br/>
<p>J.W.M.</p>
<p>We both know that Mamie would haunt me if I didn’t mention your incredible impact on my life, both creatively and personally. My best friend. No matter what happens, I’ve got your back.</p><br/>
<p>To the entire team at Austin Macauley Publishers, thank you once again for making my dream a reality while ensuring the process is as smooth as possible.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?529dfaac